import { collection, get, all, update } from "typesaurus"
import { Assessments, Activity, Role, GeoState } from "../types"
import type { TimingOptionsType } from "../testSettings"

export interface Student {
  id: string
  created: number
  createdBy?: string
  lastModified: number
  firstName: string
  lastName: string
  fullName: string
  email?: string
  externalStudentId?: string
  username?: string
  validated: boolean
  role: Role
  acrobatiq?: boolean
  acrobatiqKey?: string
  state: GeoState
  schoolDistrict: string
  school: string
  classes: { [key: string]: boolean }
  licenses: { [key: string]: boolean }
  assessments?: Assessments
  activity: Activity
  sfid?: string
  deleted?: boolean
  sourceId?: string
  verifyEmailSent: boolean
  verificationCode: string
  isVideo?: boolean
  practice?: number
  teachers: { [key: string]: boolean }
  timeAccomodation?: TimingOptionsType
  emailNotification?: boolean
  schools?: string[]
  districts?: string[]
  grade?: number | string
  graduationYear?: number | string
  loginSource?: string
}

const collection_ref = collection<Student>("students")

export const getStudentById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllStudents = () => {
  return all(collection_ref)
}

export const updateStudentById = (id: string, newVals: Partial<Student>) => {
  return update(collection_ref, id, newVals)
}
